export var URLParams;
(function (URLParams) {
    URLParams["SurveyId"] = "survey_id";
})(URLParams || (URLParams = {}));
